import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import SporttakkenComponent from "./parts/SporttakkenComponent";
import Table from "../../common/Table";
import TextInput from "../../common/TextInput";
import Button from "../../common/Button";

function getHeaders(level) {
    const headers = ["Sporttak", "Discipline", "Sub-discipline"];
    let tableHeaders = [];

    for (let i = 0; i <= level; i++) {
        if (i < 3) {
            tableHeaders.push(headers[i]);
        }
        else if (i === 3) {
            tableHeaders.splice(i - 1, 1);
            tableHeaders.push(headers[2] + ' ' + (i - 2).toString());
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
        else if (i > 3) {
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
    }

    return tableHeaders;
}

function getChildrenIds(models) {
    let ids = [];

    models.forEach(x => {
        ids.push(x.id);
        if (x.subsporttakken && x.subsporttakken.length) {
            ids.push(...getChildrenIds(x.subsporttakken));
        }
    });

    return ids;
}



const SporttakkenToevoegenForm = (props) => {
    const {
        models,
        searchResults,
        onChange,
        disabled,
        checkedSporttakken,
        onIncreaseLevel,
        level,
        filter,
        onContinueAdd,
        onCancelAdd,
        onSearch,
        onChangeFilter,
        indeterminateSporttakken,
        totalSearchResults,
        sporttakFilterHasFocus
    } = props;

    let sporttakkenForComponent = searchResults;
    let disabledSporttakken = getChildrenIds(models);

    return (
        <Section title="Sporttakken" color={types.COLOR_GREEN}>
            <Form name="sporttakken"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={onContinueAdd}
                leftButtonLabel="Annuleer"
                onLeftButtonClick={onCancelAdd}
            >
                <Fieldset>
                    <TextInput
                        name="filter"
                        label="Sporttak"
                        value={filter}
                        onChange={onChangeFilter}
                        size={3}
                        onEnter={onSearch}
                        maxLength={50}
                        hasFocus={sporttakFilterHasFocus} />
                    <Button
                        onClick={onSearch}
                        text="Zoek"
                        disabled={disabled}
                        selected
                    />
                </Fieldset>

                <Fieldset>
                    <Row>
                        {(sporttakkenForComponent && sporttakkenForComponent.length) ?
                            <Table
                                style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'frame': 'void', 'rules': 'rows' }}
                                headers={getHeaders(level)}
                            >
                                <SporttakkenComponent
                                    sporttakken={sporttakkenForComponent}
                                    checkedSporttakken={checkedSporttakken}
                                    onChange={onChange}
                                    onIncreaseLevel={onIncreaseLevel}
                                    disabledSporttakken={disabledSporttakken}
                                    indeterminateSporttakken={indeterminateSporttakken}
                                    maxLevel={level}
                                    disableChecked />
                            </Table>
                            :
                            totalSearchResults === -1 ||
                            <div>
                                <p style={{ margin: "15px 0" }}>Geen sporttakken gevonden die voldoen aan de opgegeven zoekcriteria.</p>
                            </div>
                        }
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

SporttakkenToevoegenForm.propTypes = {
    models: PropTypes.array,
    searchResults: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    checkedSporttakken: PropTypes.array,
    onIncreaseLevel: PropTypes.func,
    level: PropTypes.number,
    onContinueAdd: PropTypes.func.isRequired,
    onCancelAdd: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
    onChangeFilter: PropTypes.func.isRequired,
    disabledSporttakken: PropTypes.array,
    indeterminateSporttakken: PropTypes.array,
    totalSearchResults: PropTypes.number,
    sporttakFilterHasFocus: PropTypes.bool
};

export default SporttakkenToevoegenForm;